import { render, staticRenderFns } from "./NbHelpCard.vue?vue&type=template&id=d9873586&scoped=true&"
import script from "./NbHelpCard.vue?vue&type=script&lang=js&"
export * from "./NbHelpCard.vue?vue&type=script&lang=js&"
import style0 from "./NbHelpCard.vue?vue&type=style&index=0&id=d9873586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9873586",
  null
  
)

export default component.exports